/** Main server base URL. Empty in local `npm start` = CRA proxy. */
export function getApiBaseUrl() {
    const fromEnv = process.env.REACT_APP_API_URL?.trim() || "";
    const isLocal = /localhost|127\.0\.0\.1/i.test(fromEnv);
    if (fromEnv && !isLocal) return fromEnv;
    if (process.env.NODE_ENV !== "production") return fromEnv || "";
    throw new Error("This build is missing REACT_APP_API_URL (https://core.blutec.ai). Rebuild with client/.env.production.");
}